import Backbone from 'backbone'
import _ from 'lodash'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER, TEXT, DATE } = DataType

/**
 * Metadata about operators available to the IF clause of a transformation
 */
let ifOperators = {

	operatorsToDataTypes: null,
	enumsByDataType: null,

	/**
	 * Returns an object which combines the enumerated values for the given
	 * data types.
	 * @param [dataTypes=['text', 'number', 'date']] the data types to include
	 * in the enum
	 */
	combinedEnum: function(dataTypes=[TEXT, NUMBER, DATE]) {
		let combinedEnum = {}

		_.each(dataTypes, dataType => {
			_.extend(combinedEnum, ifOperators.enumsByDataType[dataType])
		})

		// these are filters specific to dataset fields
		delete combinedEnum['in-the-range']
		delete combinedEnum['not-in-any-range']
		// 'in-period' is for for dataset filter widgets only #16448 #16990
		delete combinedEnum['in-period']

		return combinedEnum
	}

}

Backbone.on('load', ({ enums }) => {
	// #24523 may not be defined in unit tests
	if (_.isUndefined(enums)) return

	ifOperators.operatorsToDataTypes = {}
	ifOperators.enumsByDataType = {}
	_.each([TEXT, NUMBER, DATE], dataType => {
		// enum is a reserved word, so use e for short
		let e = enums[`datasets${_.capitalize(dataType)}FilterOperator`]
		ifOperators.enumsByDataType[dataType] = e
		_.each(e, (msgKey, operator) => {
			ifOperators.operatorsToDataTypes[operator] = dataType
		})
	})
})

export default ifOperators

ifOperators.__filename__ = 'imports/transform/if-operators.js'
